import { useQuery } from '@tanstack/react-query'
import { grantApi } from '../lib/api'

export const GRANT_IMPACT_KEY = ['grant', 'impact'] as const

/** [Phase 8 / P8-12] Online read; React Query keeps the last data for offline display. Removed on logout. */
export function useGrantImpact() {
  return useQuery({
    queryKey: GRANT_IMPACT_KEY,
    queryFn: async () => (await grantApi.impact()).data,
    retry: false,
    staleTime: 60_000,
  })
}
